import { render, staticRenderFns } from "./FeeBulkUploadStudentsComponent.vue?vue&type=template&id=3cda7b30&"
import script from "./FeeBulkUploadStudentsComponent.vue?vue&type=script&lang=js&"
export * from "./FeeBulkUploadStudentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports